import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { GeoAddress } from "../../domain";
import { GeoCoordinatesRequest } from "../../domain";
import { GeoCoordinateRepository } from "../../repositories";

@Injectable({ providedIn: 'root' })
export class GetGeoCoordinatesUsecase implements UseCase<GeoCoordinatesRequest, GeoAddress> {

  constructor(private geoCoordinatesRepository: GeoCoordinateRepository) {
  }

  execute(params: GeoCoordinatesRequest): Observable<GeoAddress> {
    return this.geoCoordinatesRepository.getGeoCoordinates(params);
  }

}
